import { render } from "./RecentlyAdded.vue?vue&type=template&id=5a47302c&scoped=true"
import script from "./RecentlyAdded.vue?vue&type=script&lang=js"
export * from "./RecentlyAdded.vue?vue&type=script&lang=js"

import "./RecentlyAdded.vue?vue&type=style&index=0&id=5a47302c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a47302c"]])

export default __exports__